export default {
    folders: [],
    selectedFolder: {
        id: 0,
        contents: [],
    },
    isLoading: false,
};
